module.exports = __webpack_public_path__ + "static/media/Orbit-mks.cdda86e4.png";